var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".langARimage li a[data-v-f7ad2b20]{font-weight:700;font-size:14px}.langARimage li a[data-v-f7ad2b20]:after{content:\"\";display:block;margin:0;float:right;background:url(" + escape(require("../../img/caret-left.svg")) + ") no-repeat;width:10px;height:10px;position:absolute;left:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.langAR[data-v-f7ad2b20]{text-align:right}.langEN[data-v-f7ad2b20]{text-align:left}.langENimage li a[data-v-f7ad2b20]{font-weight:700;font-size:14px}.langENimage li a[data-v-f7ad2b20]:after{content:\"\";display:block;margin:0;float:right;background:url(" + escape(require("../../img/caret-right.svg")) + ") no-repeat;width:10px;height:10px;position:absolute;right:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f7ad2b20","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Page.vue
// module id = EW+n
// module chunks = 80